import { render, staticRenderFns } from "./recentexport.vue?vue&type=template&id=be192124&scoped=true&"
import script from "./recentexport.vue?vue&type=script&lang=js&"
export * from "./recentexport.vue?vue&type=script&lang=js&"
import style0 from "./recentexport.vue?vue&type=style&index=0&id=be192124&scoped=true&lang=css&"
import style1 from "./recentexport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be192124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VChip,VContainer,VDataTable,VFlex,VIcon,VLayout,VTextField})
